module.exports = __webpack_public_path__ + "img/MapThumb_Wildwoods.df8a2af2.webp";